/**
 * Пакетное создание строк графика и сохранение порядка как в шаблоне.
 */
import { saveScheduleOrder, clearScheduleOrder } from './scheduleOrderStorage';

const DEFAULT_BATCH_SIZE = 50;

/**
 * @param {import('axios').AxiosInstance} client
 * @param {object[]} batchData
 * @param {number} batchSize
 * @returns {Promise<object[]>}
 */
export async function postSchedulesBatch(client, batchData, batchSize = DEFAULT_BATCH_SIZE) {
  const created = [];
  for (let i = 0; i < batchData.length; i += batchSize) {
    const response = await client.post('/schedules/batch', batchData.slice(i, i + batchSize));
    const chunk = response.data || [];
    created.push(...chunk);
  }
  return created;
}

/**
 * Сохраняет порядок id после заполнения шаблоном / импорта.
 * @param {number|string} cityId
 * @param {string} scheduleType
 * @param {object[]} createdRows — ответ API batch, в порядке шаблона
 * @param {object[]} [existingRows] — уже сохранённые строки до добавления
 * @param {boolean} [replaceOrder] — true если график был пуст (только шаблон)
 */
export function persistOrderAfterBatchFill(
  cityId,
  scheduleType,
  createdRows,
  existingRows = [],
  replaceOrder = false
) {
  if (!cityId || !scheduleType) return;

  const existingIds = (existingRows || [])
    .filter((s) => s?.id != null && !String(s.id).startsWith('new-'))
    .map((s) => s.id);

  const newIds = (createdRows || []).map((s) => s.id).filter((id) => id != null);

  if (replaceOrder || existingIds.length === 0) {
    clearScheduleOrder(cityId, scheduleType);
    saveScheduleOrder(
      cityId,
      scheduleType,
      newIds.map((id) => ({ id }))
    );
    return;
  }

  const merged = [...existingIds];
  newIds.forEach((id) => {
    if (!merged.includes(id)) merged.push(id);
  });
  saveScheduleOrder(
    cityId,
    scheduleType,
    merged.map((id) => ({ id }))
  );
}

/**
 * Сортирует строки по порядку элементов шаблона (fallback).
 */
export function sortSchedulesByTemplate(schedules, templateItems, keyFn) {
  if (!templateItems?.length || !schedules?.length) return schedules;

  const indexByKey = new Map();
  templateItems.forEach((item, index) => {
    const key = keyFn(item);
    if (key != null && key !== '' && !indexByKey.has(key)) {
      indexByKey.set(key, index);
    }
  });

  return [...schedules].sort((a, b) => {
    const ia = indexByKey.get(keyFn(a)) ?? Number.MAX_SAFE_INTEGER;
    const ib = indexByKey.get(keyFn(b)) ?? Number.MAX_SAFE_INTEGER;
    if (ia !== ib) return ia - ib;
    return (a.id ?? 0) - (b.id ?? 0);
  });
}
